export enum ConversationType {
    Support = 'support',
    Feedback = 'feedback',
    Docs = 'docs',
    Enterprise = 'enterprise',
    Startup = 'startup',
    Partner = 'partner',
    Sponsorship = 'sponsorship',
}
